
import { createStyles } from '@svg/antd/es/theme/utils';

export default createStyles(({ token, css }) => {
    return {
        ellipsisTooltipTextBox: css`
            width: 100%;
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `,
    }
});